import styles from './SurveyIntro.module.scss';

export const getHighlighterProps = (textToHighlight: string, searchWords?: string) => {
  return {
    searchWords: [searchWords ?? ''],
    textToHighlight,
    autoEscape: true,
    highlightClassName: styles.surveyIntroSearchHighlightColor
  };
};
